module.exports = __webpack_public_path__ + "static/media/Anexo_tarifas.d4652e31.pdf";